import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@mui/styles";
import HoverPopover from "material-ui-popup-state/HoverPopover";
import PopupState, { bindHover, bindPopover } from "material-ui-popup-state";
import { Box } from "@mui/material";

const styles = (theme) => ({
  popover: {
    pointerEvents: "none",
  },
  paper: {
    padding: theme?.spacing?.unit,
    backgroundColor: "unset",
    boxShadow: "unset",
  },
});

const HoverPopoverPopupState = ({ classes, id, content, children }) => (
  <PopupState variant="popover" popupId={id}>
    {(popupState) => (
      <Box {...bindHover(popupState)}>
        {children}
        <HoverPopover
          disableScrollLock
          {...bindPopover(popupState)}
          className={classes.popover}
          classes={{
            paper: classes.paper,
          }}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
        >
          {content}
        </HoverPopover>
      </Box>
    )}
  </PopupState>
);

HoverPopoverPopupState.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(HoverPopoverPopupState);
